import { createZodDto } from "nestjs-zod/dto";
import z from "zod";
import { referencePeriodSchema } from "../reference-period/reference-period";
import { referralRewardRuleSchema } from "../referral-reward-rule/referral-reward-rule";
import { souscriptionSchema, souscriptionWithUserSchemaAndPayment } from "../souscription";
import { userSchema } from "../user";

export const bonusSchema = z.object({
  id: z.string(),
  amount: z.number().nullable().optional(),
  userId: z.string().nullable().optional(),
  user: userSchema.nullable().optional(),
  souscriptionId: z.string().nullable().optional(),
  souscription: souscriptionSchema.optional().nullable(),
  ruleRefenrenceRewardId: z.string().nullable().optional(),
  ruleRefenrenceReward: referralRewardRuleSchema.nullable().optional(),
  periodId: z.string().nullable().optional(),
  period: referencePeriodSchema.nullable().optional(),
  createdAt: z.coerce.date(),
});

const createBonusSchema = bonusSchema.pick({
  amount: true,
  userId: true,
  souscriptionId: true,
  ruleRefenrenceRewardId: true,
  periodId: true,
});

export class BonusDto extends createZodDto(bonusSchema) {}
export class CreateBonusDto extends createZodDto(createBonusSchema) {}
